export default __webpack_public_path__ + "static/media/canoncito-health-center-inc.19c235dd.jpg";